/**
 * Stroke text on a canvas.
 *
 * The layout itself — where each pen stroke goes — lives in core
 * (`font/text.ts`), because the Gerber writer needs exactly the same geometry:
 * a silkscreen plot has to carry the same lettering the screen shows, and two
 * implementations of the same font layout would drift. Only the part that
 * touches a `CanvasRenderingContext2D` is here.
 */

export {
  layoutText, measure, substituteParams,
  type StrokeTextOptions, type TextLayout,
} from '@sircad/core/font/text.ts';

import type { TextLayout } from '@sircad/core/font/text.ts';

/**
 * Draw stroke text onto a canvas.
 *
 * `lineWidth` is in device pixels and set by the caller, because pen width for
 * text in the original is a display property rather than stored per string.
 */
export function drawText(
  ctx: CanvasRenderingContext2D,
  layout: TextLayout,
  toScreenX: (x: number) => number,
  toScreenY: (y: number) => number,
): void {
  ctx.beginPath();
  for (const s of layout.strokes) {
    if (s.length < 4) continue;
    ctx.moveTo(toScreenX(s[0]!), toScreenY(s[1]!));
    for (let i = 2; i < s.length; i += 2) {
      ctx.lineTo(toScreenX(s[i]!), toScreenY(s[i + 1]!));
    }
  }
  ctx.stroke();
}
